// Device Service

// Check whether user device fits within certain media query; e.g.: < 640px (mobile)
// Check whether device supports touch
// NB: this will not update if user re-sizes window

(function () {
    "use strict";

    // @ngInject
    Services.DeviceService = function DeviceService(Modernizr, $window) {
        const modernizr = Modernizr;
        this.device = {};

        // add media queries that we have in base/_grid.css.scss
        const mediaQueryEnums = {
            mobileSize: {query: 'only all and (max-width: 640px)'},
            ipadMaxSize: {query: 'only all and (max-width: 1024px)'},
            nxSmallBreakPoint: {query: 'only all and (max-width: 768px)'},
            xLargeBreakPoint: {query: 'only all and (max-width: 1200px)'},
            navLargeBreakPoint: {query: 'only all and (max-width: 992px)'}
        };

        this.checkIfMobileSize = () => {
            const mobileScreenSize = mediaQueryEnums.mobileSize.query; // 640px
            // mobile screens or small browser windows
            this.device.isMobileSize = modernizr.mq(mobileScreenSize);
            return this.device.isMobileSize;
        };

        this.isIpadScreenSizeOrSmaller = () => {
            const ipadMaxScreenSize = mediaQueryEnums.ipadMaxSize.query; // 640px
            // mobile screens or small browser windows
            this.device.ipadMaxSize = modernizr.mq(ipadMaxScreenSize);
            return this.device.ipadMaxSize;
        };

        this.xLargeBreakPoint = () => {
            const xLargeScreenSize = mediaQueryEnums.xLargeBreakPoint.query;
            // Navigation Large breakpoint >= 1200px
            this.device.xLargeMaxSize = modernizr.mq(xLargeScreenSize);
            return this.device.xLargeMaxSize;
        };

        this.nxSmallBreakpoint = () => {
            const nxSmallBreakpoint = mediaQueryEnums.nxSmallBreakPoint.query; // 768px
            this.device.nxSmallMaxSize = modernizr.mq(nxSmallBreakpoint);
            return this.device.nxSmallMaxSize;
        };

        this.navLargeBreakPoint = () => {
            const navMaxLargeScreenSize = mediaQueryEnums.navLargeBreakPoint.query;
            // Navigation Large breakpoint >= 992px
            this.device.navLargeMaxSize = modernizr.mq(navMaxLargeScreenSize);
            return this.device.navLargeMaxSize;
        };

        this.checkIfTouchScreen = () => {
            return modernizr.touchevents;
        };

        this.checkIfTouchDevice = () => {

            const isMobile = {
                Android: () =>  {
                    return navigator.userAgent.match(/Android/i);
                },
                BlackBerry: () => {
                    return navigator.userAgent.match(/BlackBerry/i);
                },
                iOS: () => {
                    return navigator.userAgent.match(/iPhone|iPad|iPod/i);
                },
                Opera: () => {
                    return navigator.userAgent.match(/Opera Mini/i);
                },
                Windows: () => {
                    return navigator.userAgent.match(/IEMobile/i);
                },
                any: () => {
                    return ( isMobile.Android() || isMobile.BlackBerry() || isMobile.iOS() || isMobile.Opera() || isMobile.Windows() );
                }
            };

            return isMobile.any();
        };

        //NOTE: http://stackoverflow.com/questions/5899783/detect-safari-using-jquery
        this.isSafari = () => {
            return navigator.userAgent.indexOf('Safari') !== -1 && navigator.userAgent.indexOf('Chrome') === -1;
        };

        this.isEdge = () => {
            return /Edge\/\d./i.test(navigator.userAgent);
        };

        this.isFireFox = () => {
            return navigator.userAgent.toLowerCase().indexOf('firefox') > -1;
        };


        this.isInAppBrowser = () => {
            if (window && window.isHBInAppBrowser) {
                return true;
            }
            return this.isIOS() && navigator.userAgent.indexOf('Safari') === -1;
        };

        this.getMobileOs = (osParams) => {
            const ua = navigator.userAgent;
            let uaindex;
            let versionEndIndex;

            // determine OS
            if ( ua.match(/iPad/i) || ua.match(/iPod/i) || ua.match(/iPhone/i) )
            {
                osParams.mobileOs = 'iOS';
                uaindex = ua.indexOf( 'OS ' );
                versionEndIndex = uaindex + ua.substring(uaindex).indexOf(';');
            }
            else if ( ua.match(/Android/i) )
            {
                osParams.mobileOs = 'Android';
                uaindex = ua.indexOf( 'Android ' );
                versionEndIndex = uaindex + ua.substring(uaindex).indexOf(';');
            }

            // determine version
            if ( osParams.mobileOs === 'iOS'  &&  uaindex > -1 )
            {
                osParams.iosVersion = ua.substr( uaindex + 3, 3 ).replace( '_', '.' );
            }
            else if ( osParams.mobileOs === 'Android'  &&  uaindex > -1 )
            {
                osParams.androidVersion = ua.substr( uaindex + 8, versionEndIndex - (uaindex + 8) );
            }
        };

        this.isIOS = () => {
            if (this.checkIfTouchDevice()) {
                let mobileOsParams = {};
                this.getMobileOs(mobileOsParams);
                if (mobileOsParams.mobileOs === 'iOS') {
                    return true;
                }
            }

            return false;
        };

        this.isAndroid = () => {
            if (this.checkIfTouchDevice()) {
                let mobileOsParams = {};
                this.getMobileOs(mobileOsParams);
                if (mobileOsParams.mobileOs === 'Android') {
                    return true;
                }
            }

            return false;
        };

        this.isTablet = () => {
            var userAgent = navigator.userAgent.toLowerCase();
            const isTablet = /(ipad|tablet|(android(?!.*mobile))|(windows(?!.*phone)(.*touch))|kindle|playbook|silk|(puffin(?!.*(IP|AP|WP))))/.test(userAgent);
            return userAgent.match(/(ipad|tablet|(android(?!.*mobile))|(windows(?!.*phone)(.*touch))|kindle|playbook|silk|(puffin(?!.*(IP|AP|WP))))/i) != null;
        };

        this.checkIfMobileSize();

        angular.element($window).bind('resize', function(){
            this.checkIfMobileSize();
            this.nxSmallBreakpoint();
        }.bind(this));
    };
}());
